
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/custom-software-development",
      function () {
        return require("private-next-pages/services/custom-software-development.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/custom-software-development"])
      });
    }
  